// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1l-0";
export var spinnerContainer = "_1l-1";